<template>
    <div :class="{'disabled' : !active}">

        <p class="h3 reduce-margin">Payment & Extra Details</p>
        <template v-if="active">
            <template v-if="showNewsletter">
                <news-letter-signup :email="order.billing_details.email" :trigger-save="trigger" />
                <hr>
            </template>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="orderReference">Order Reference</label>
                        <input id="orderReference" type="text" class="form-control" v-model="reference">
                    </div>
                    <div class="form-group">
                        <label for="orderNotes">Order Notes</label>
                        <textarea id="orderNotes" class="form-control" v-model="notes"></textarea>
                    </div>
                </div>

                <div class="col-md-12" v-if="showCharity">
                    <charity-donation></charity-donation>
                    <br>
                </div>
                <div class="col-md-12" v-if="showCatalogue">
                    <catalogue-order :billing-email="order.billing_details.email"></catalogue-order>
                </div>
            </div>
                <template v-if="shipping">
                    <!-- <template v-if="shipping.sku == 'yel5o9pw'">
                        <collection-gateway
                            v-if="collectionGateway"
                            :gateway-id="collectionGateway.id"
                            @failed="fail"
                            @start="start"
                            @complete="complete"
                        ></collection-gateway>
                    </template> -->
                    <template v-if="shipping.sku == '1q6v393n'">
                        <get-delivery-quotation-gateway
                            v-if="quoteGateway"
                            :gateway-id="quoteGateway.id"
                            @failed="fail"
                                    @start="start"
                                    @complete="complete"
                        ></get-delivery-quotation-gateway>
                    </template>
                    <template v-else-if="!accountNo">
                        <ul class="nav nav-tabs checkout__tabs">
                            <li
                                role="presentation"
                                :class="{'active': gateway == provider.driver}"
                                v-for="provider in gateways"
                                :key="provider.id">
                                    <a href="#" @click.prevent="setGateway(provider)">Pay by {{ provider.name }}</a>
                            </li>
                        </ul>
                        <div class="tab">
                            <div class="tab-content">
                                <template v-if="gateway == 'sagepay'">
                                    <div v-if="isCollection" class="alert alert-warning">
                                        You will be required to show the payment card when you come to collect your order.
                                    </div>
                                    <sagepay-gateway
                                        :guest="guest"
                                        @failed="fail"
                                        @start="start"
                                        @complete="complete"
                                    ></sagepay-gateway>
                                </template>

                                <template v-if="gateway == 'paypal'">
                                    <div v-if="isCollection" class="alert alert-warning">
                                        Photographic ID (Passport / Driving License) will be required when you come to collect your order.
                                    </div>
                                    <paypal-gateway
                                        :env="paypalEnv"
                                        v-if="gateway == 'paypal'"
                                        :gateway-id="gatewayId"
                                        @failed="fail"
                                        @start="start"
                                        @complete="complete"
                                    >
                                    </paypal-gateway>
                                </template>

                                <offline-gateway
                                    v-if="gateway == 'offline'"
                                    :phone-only="isCollection"
                                    :gateway-id="gatewayId"
                                    @start="start"
                                    @failed="fail"
                                    @complete="complete"
                                >
                                </offline-gateway>

                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <account-gateway
                            :gateway-id="onAccountGateway.id"
                            @failed="fail"
                            @start="start"
                            @complete="complete"
                            v-if="onAccountGateway">
                        </account-gateway>
                    </template>
                <template v-if="failed">
                    <hr>
                    <div class="alert alert-danger">
                        <strong>Payment Failed</strong><br>
                        <p>We were unable to process your payment, please check all details, including the Card Holder Address and try again.</p>
                    </div>
                </template>
            </template>
        </template>
    </div>
</template>

<script>
    import Order from '../../Services/Order.js';
    import Checkout from '../../Services/Checkout.js';
    import CatalogueOrder from './CatalogueOrder.vue';
    import CharityDonation from './CharityDonation.vue';
    import PaypalGateway from './Payments/PaypalGateway.vue';
    import SagepayGateway from './Payments/SagepayGateway.vue';
    import OfflineGateway from './Payments/OfflineGateway.vue';
    import GetDeliveryQuotationGateway from './Payments/GetDeliveryQuotationGateway.vue';
    import AccountGateway from './Payments/AccountGateway.vue';
    import CollectionGateway from './Payments/CollectionGateway.vue';
    import NewsLetterSignup from './NewsletterSignup.vue';

    export default {
        props: {
            isCollection: {
                type: Boolean,
                default: false
            },
            allowOfflinePayment: {
                type: Boolean,
                default: true
            },
            showNewsletter: {
                type: Boolean,
                default: true
            },
            showCharity: {
                type: Boolean,
                default: true
            },
            showCatalogue: {
                type: Boolean,
                default: true
            },
            paypalEnv: {
                type: String,
                default: 'sandbox',
            },
            step: {
                default: 4
            },
            guest: {
                default: true,
            },
            accountNo: {
                default: null
            },
        },
        components: {
            SagepayGateway,
            PaypalGateway,
            OfflineGateway,
            CharityDonation,
            CatalogueOrder,
            AccountGateway,
            GetDeliveryQuotationGateway,
            CollectionGateway,
            NewsLetterSignup
        },
        data() {
            return {
                service: Order,
                gateway: "sagepay",
                gatewayId: null,
                gateways: [],
                hasFocus: true,
                failed: false,
                trigger: false,
                notes: null,
                reference: null,
                checkout: Checkout,
                onAccountGateway: null,
                quoteGateway: null,
                collectionGateway: null,
            }
        },
        mounted() {
            Checkout.getGateways().then(response => {
                this.gateways = _.filter(response, gateway => {
                    if (gateway.handle == 'over-phone' && !this.allowOfflinePayment) {
                        return false;
                    }
                    if (!this.isCollection && gateway.handle == 'collection-phone-payment') {
                        return false;
                    }
                    return gateway.handle != 'collection' &&
                        gateway.handle != 'on-account' &&
                        gateway.handle != 'delivery-quotation';
                });
                this.onAccountGateway = _.find(response, gateway => gateway.handle == 'on-account');
                this.quoteGateway = _.find(response, gateway => gateway.handle == 'delivery-quotation');
                this.collectionGateway = _.find(response, gateway => gateway.handle == 'collection');
            });
        },
        watch: {
            notes: function (val) {
                this.service.setNotes(val);
            },
            reference: function (val) {
                this.service.setReference(val);
            }
        },
        computed: {
            active() {
                return this.checkout.step >= this.step;
            },
            processed() {
                return Order.order;
            },
            shipping() {
                return this.service.getShippingLine();
            },
            order() {
                return this.service.order;
            }
        },
        methods: {
            setGateway(provider) {
                this.gateway = provider.driver;
                this.gatewayId = provider.id;
            },
            start() {
                this.failed = false;
                this.trigger = true;
                this.$emit('processing', true);
            },
            fail() {
                this.failed = true;
                this.$emit('processing', false);
            },
            complete() {
                window.location = '/checkout/confirmation';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .nav-tabs {
        margin-top:2em;
    }
    .tab {
        border:1px solid #ddd;
        border-radius:4px;
        .tab-content {
            padding:2em 2%;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/Components/Checkout/PaymentDetails.vue